<template>
    <slot name="filter-field-selector-options" v-bind="this"></slot>
</template>

<script>
    export default {

        props: {
            modelValue:null,
            name: null,
            option: null,
            index: null
        },

        data() {
            return {
                checked: this.option.checked || false,
                isChecked: this.option.checked || false
            }
        },

        watch: {
            checked() {
                this.$emit('input', this.checked)
            },
            value() {
                this.checked = this.value
            }
        },

        methods: {
            change(e) {
                this.checked = !this.checked;
                this.option.checked = this.checked;
                this.isChecked = this.checked;
                this.$emit('change', this.option);
            },
        },



    }
</script>
